import { Controller } from "@hotwired/stimulus"

// Find a clean copy on a painted picture (dashboard/dropped_pictures/_painted): a picture pasted into a box (copied
// from a search result), dropped on it or chosen, or its address pasted, fills that box; once every box showing is
// filled (one, or two when the photo was two put together) they're sent at once: pasting means Steve wants them.
// The window closes and the painted copy shows it's being swapped till the card comes back with them in its place.
export default class extends Controller {
  static targets = ["form", "slot", "two"]

  paste(event) {
    const slot = event.target.closest(".dp-drop")
    const picture = [...(event.clipboardData?.files || [])].find((file) => file.type.startsWith("image/"))
    if (picture) {
      event.preventDefault()
      return this.useFile(slot, picture)
    }
    const text = event.clipboardData?.getData("text").trim()
    if (/^https?:\/\/\S+$/.test(text || "")) {
      event.preventDefault()
      this.useAddress(slot, text)
    }
  }

  enter(event) {
    event.preventDefault()
    const slot = event.target.closest(".dp-drop")
    if (event.target.value.trim()) this.useAddress(slot, event.target.value.trim())
  }

  over(event) {
    event.preventDefault()
    event.currentTarget.classList.add("is-over")
  }

  leave(event) { event.currentTarget.classList.remove("is-over") }

  drop(event) {
    event.preventDefault()
    const slot = event.currentTarget
    slot.classList.remove("is-over")
    const picture = [...(event.dataTransfer?.files || [])].find((file) => file.type.startsWith("image/"))
    if (picture) return this.useFile(slot, picture)
    const text = (event.dataTransfer?.getData("text/uri-list") || event.dataTransfer?.getData("text") || "").trim().split("\n")[0]
    if (/^https?:\/\//.test(text)) this.useAddress(slot, text)
  }

  choose(event) { event.target.closest(".dp-drop").querySelector("input[type=file]").click() }

  picked(event) {
    const slot = event.target.closest(".dp-drop")
    const picture = event.target.files[0]
    if (picture) this.filled(slot, URL.createObjectURL(picture))
  }

  two() {
    const second = this.slotTargets[1]
    second.hidden = !this.twoTarget.checked
    second.querySelectorAll("input").forEach((input) => { input.disabled = second.hidden })
    if (this.twoTarget.checked) this.nextEmpty()?.querySelector("input[type=text]").focus()
    else this.sendIfReady()
  }

  useFile(slot, picture) {
    const transfer = new DataTransfer()
    transfer.items.add(picture)
    slot.querySelector("input[type=file]").files = transfer.files
    slot.querySelector("input[type=text]").value = ""
    this.filled(slot, URL.createObjectURL(picture))
  }

  // An address can't be shown before it's fetched (the page shows only our own pictures), so the box just says so.
  useAddress(slot, address) {
    slot.querySelector("input[type=file]").value = ""
    slot.querySelector("input[type=text]").value = address
    this.filled(slot, null)
  }

  filled(slot, preview) {
    const img = slot.querySelector(".dp-drop-preview")
    img.hidden = !preview
    if (preview) img.src = preview
    slot.classList.add("is-filled")
    this.sendIfReady()
  }

  get showing() { return this.slotTargets.filter((slot) => !slot.hidden) }

  nextEmpty() { return this.showing.find((slot) => !slot.classList.contains("is-filled")) }

  sendIfReady() {
    const empty = this.nextEmpty()
    if (empty) return empty.querySelector("input[type=text]").focus()
    this.card?.classList.add("is-swapping")
    this.element.close()
    this.formTarget.requestSubmit()
  }

  // A picture that couldn't be used leaves the card as it was (the reason shows at the top); one that could
  // redraws the card.
  done() { this.card?.classList.remove("is-swapping") }

  get card() { return this.element.closest(".dp-card") }
}
